if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends HTMLElement {
      constructor() {
        super();
    
        if (Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get section() {
        return this._section = this._section || this.closest('.mobile-dock-section');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('loaded', '');

        if (this.hasAttribute('data-always-visible')) {
          this.section.classList.add('active');
        }
        else {
          this.detectForHeader();
          this.detectForFooter();
        }

        // Publish --mobile-dock-height reliably so everything that positions
        // off the dock (WhatsApp button, sticky filter, footer padding) is
        // correct on first paint — not only after a scroll. rAF covers initial
        // layout, load covers late reflow (fonts/images), matchSmall covers the
        // breakpoint switch, and a ResizeObserver keeps it in sync if the dock's
        // own height ever changes. (Previously a single setTimeout could read a
        // 0/stale height, so dependents sat in the wrong place until a scroll.)
        const setHeight = this.setHeight.bind(this);
        requestAnimationFrame(setHeight);
        window.addEventListener('load', setHeight);
        document.addEventListener('matchSmall', setHeight);
        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(setHeight);
          this._resizeObserver.observe(this);
        }
    
        if (Shopify.designMode) {
          this.section.addEventListener('shopify:section:select', () => {
            this.section.classList.add('shopify-active');
          });
          this.section.addEventListener('shopify:section:deselect', () => {
            this.section.classList.remove('shopify-active');
          });
        }
      }
    
      detectForHeader() {
        const header = document.querySelector('.header-section');
        if (header === null) {
          this.section.classList.add('active');
          return;
        }

        // "Always visible" OFF → smart show/hide on scroll, INDEPENDENT of the
        // header's sticky setting: show when scrolling down, hide when scrolling
        // up or near the top. (Previously this was coupled to .header-hidden;
        // now the header and dock are decoupled, so the dock owns this logic.)
        this.topThreshold = parseInt(header.getBoundingClientRect().bottom) || 0;
        this.lastScrollY = window.scrollY;
        window.addEventListener('scroll', theme.utils.throttle(this.onScrollForHeader.bind(this)), false);
      }

      onScrollForHeader() {
        const y = Math.max(0, window.scrollY);
        if (y <= this.topThreshold) {
          this.section.classList.remove('active');        // near the top → hide
        }
        else if (y > this.lastScrollY + 2) {
          this.section.classList.add('active');           // scrolling down → show
        }
        else if (y < this.lastScrollY - 2) {
          this.section.classList.remove('active');        // scrolling up → hide
        }
        this.lastScrollY = y;
      }
    
      detectForFooter() {
        const footer = document.querySelector('.footer-copyright');
        if (footer === null) return;
    
        window.addEventListener('scroll', theme.utils.throttle(this.onScrollForFooter.bind(this)), false);
      }
    
      onScrollForFooter() {
        if (!theme.config.mqlSmall) return;
        
        const scrolledTo = window.scrollY + window.innerHeight;
        const threshold = this.offsetHeight;
        const isReachBottom = document.body.scrollHeight - threshold <= scrolledTo;
        this.classList.toggle('active', isReachBottom);
      }
    
      setHeight() {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.getBoundingClientRect().height.toFixed(1)}px`);
      }
    }, { extends: 'nav' }
  );
}
